import React from "react";

export const Num = ({ value, suffix = "", decimals = 2, signed = false, className = "" }) => {
  if (value === null || value === undefined || isNaN(value)) {
    return <span className={`font-mono-data text-[#555] ${className}`}>—</span>;
  }
  const v = Number(value);
  let colored = "";
  if (signed) {
    if (v > 0) colored = "pos";
    else if (v < 0) colored = "neg";
    else colored = "text-[#8a8a8e]";
  }
  const sign = signed && v > 0 ? "+" : "";
  return (
    <span className={`font-mono-data ${colored} ${className}`}>
      {sign}{v.toFixed(decimals)}{suffix}
    </span>
  );
};

export const ScoreBar = ({ score }) => {
  const v = Math.max(-100, Math.min(100, Number(score) || 0));
  const w = Math.abs(v);
  const isPos = v >= 0;
  return (
    <div className="flex items-center gap-2">
      <div className="relative w-16 h-1 bg-[#1a1a1a]">
        <div
          className={`absolute top-0 ${isPos ? "left-1/2 bar-pos" : "right-1/2 bar-neg"} h-1`}
          style={{ width: `${w / 2}%` }}
        />
        <div className="absolute top-[-2px] left-1/2 w-px h-2 bg-[#444]" />
      </div>
      <span className={`font-mono-data text-xs ${isPos ? "pos" : "neg"}`}>{v.toFixed(0)}</span>
    </div>
  );
};

export const Badge = ({ children, variant = "default" }) => {
  const map = {
    default: "border-[#222] text-[#8a8a8e]",
    positive: "border-[#00e676]/40 text-[#00e676]",
    negative: "border-[#ff3b30]/40 text-[#ff3b30]",
    warning: "border-[#ffcc00]/40 text-[#ffcc00]",
  };
  return (
    <span className={`inline-block px-1.5 py-0.5 text-[10px] font-mono-data uppercase tracking-wider border ${map[variant]}`}>
      {children}
    </span>
  );
};
